import browser from 'webextension-polyfill';
import { getTabvanaWindowId, setTabvanaWindowId } from '../db/prefs';

export async function openTabvana() {
  let w: browser.Windows.Window | null = null;
  const mainUrl = browser.runtime.getURL('src/main/main.html');

  const tabvanaWindowId = await getTabvanaWindowId();
  if (tabvanaWindowId != null) {
    try {
      w = await browser.windows.get(tabvanaWindowId, { populate: true });
      // After an extension reload the tab may be blank — navigate it back.
      if (w.tabs && w.tabs.length > 0) {
        const tab = w.tabs[0];
        if (tab.id != null && tab.url !== mainUrl) {
          await browser.tabs.update(tab.id, { url: mainUrl });
        }
      }
    } catch (e) {
      await setTabvanaWindowId(undefined);
    }
  }

  if (w == null) {
    w = await browser.windows.create({
      url: mainUrl,
      type: 'popup',
    });
  }

  if (w == null) {
    throw new Error('Could not open Tabvana window');
  } else {
    if (w.id != null) {
      await setTabvanaWindowId(w.id);
      await browser.windows.update(w.id, { focused: true });
    }
  }
}
